<template>
  <el-dialog :visible.sync="editVisible" width="450px" :show-close="false">
    <div slot="title">
      <p>修改账号</p>
      <i class="el-icon-error" @click="editVisible = false" style="cursor:pointer"></i>
    </div>
    <el-form :model="userForm" :rules="rules" ref="userForm" label-position="top">
      <el-form-item prop="realName" label="真实姓名：">
        <el-input v-model="userForm.realName" placeholder="请输入真实姓名"></el-input>
      </el-form-item>
      <el-form-item prop="phone" label="手机号：">
        <el-input v-model="userForm.phone" placeholder="请输入手机号"></el-input>
      </el-form-item>
      <el-form-item prop="certNo" label="监督证号：">
        <el-input v-model="userForm.certNo" placeholder="请输入监督证号"></el-input>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialogBtn">
      <el-button @click="editVisible = false">取 消</el-button>
      <el-button type="primary" @click="submitForm">确 定</el-button>
    </div>
  </el-dialog>
</template>
<script>
import {
  getuserById,
  edituser
  // addlogoperate
} from "../../axios/api.js";
export default {
  data() {
    return {
      editVisible: false,
      userForm: {
        realName: "",
        phone: "",
        certNo: "",
        // mailbox: ''，
        email: ""
        // password: ''
      },
      rules: {
        phone: [
          {
            required: true,
            validator: this.$validator.phone,
            trigger: "blur"
            // pattern: new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/, "g"),
          },
          {
            required: false,
            pattern: new RegExp(/^[1][3,4,5,6,7,8,9][0-9]{9}$/, "g"),
            message: "请输入手机号"
          }
        ],
        realName: [
          { required: true, message: "请输入真实姓名", trigger: "blur" }
        ],
        email: [
          {
            required: true,
            message: "请输入邮箱",
            trigger: "blur",
            validator: this.$validator.email
          }
        ]
      }
    };
  },
  mounted() {},
  methods: {
    openVisible(id) {
      console.log(id);
      // const params = {
      //   id: id
      // };
      getuserById([id]).then(res => {
        if (res && res.code === 200) {
          console.log(res);
          this.userForm.realName = res.data.nickname;
          this.userForm.phone = res.data.phone;
          this.userForm.id = id;
          this.userForm.certNo = res.data.certNo;
          this.realname = res.data.realName;
          this.phone = res.data.phone;
          this.email = res.data.email;
          this.editVisible = true;
        }
      });
    },
    submitForm() {
      this.$refs.userForm.validate(valid => {
        console.log(valid);
        console.log(this.userForm);
        if (valid) {
          edituser([
            this.userForm.id,
            this.userForm.realName,
            this.userForm.id,
            this.userForm.phone,
            this.userForm.certNo
          ]).then(res => {
            if (res && res.code === 200) {
              this.$message.success("修改用户成功");

              // var list = "";

              // if (this.realname !== this.userForm.realName) {
              //   list +=
              //     "把" +
              //     this.realname +
              //     "修改为" +
              //     this.userForm.realName +
              //     "，";
              // }

              // if (this.phone !== this.userForm.phone) {
              //   list +=
              //     "把" + this.phone + "修改为" + this.userForm.phone + "，";
              // }
              // if (this.email !== this.userForm.email) {
              //   list +=
              //     "把" + this.email + "修改为" + this.userForm.email + "，";
              // }

              // const params = {
              //   userName: localStorage.getItem("username"),
              //   content: `${localStorage.getItem("username") +
              //     "修改了" +
              //     this.realname +
              //     "的账号：" +
              //     list}`,
              //   type: 5,
              //   operateTime: this.$moment(new Date()).format(
              //     "yyyy-MM-DD HH:mm:ss"
              //   ),
              //   platform: 7,
              //   module: "用户管理"
              // };
              // addlogoperate(params).then(res => {
              //   console.log(res.data);
              // });

              this.editVisible = false;
              this.$emit("editsuccess", true);
            }
          });
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
};
</script>
<style  scoped>
::v-deep .el-dialog__body {
  padding: 0px 20px;
}

::v-deep .el-form--label-top .el-form-item__label {
  padding: 0;
}

::v-deep .el-form-item {
  margin: 10px;
}
</style>
